function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 0.75C4.16797 0.75 0.25 4.66797 0.25 9.5C0.25 14.332 4.16797 18.25 9 18.25C13.832 18.25 17.75 14.332 17.75 9.5C17.75 4.66797 13.832 0.75 9 0.75ZM12.75 9.96875C12.75 10.0547 12.6797 10.125 12.5938 10.125H9.625V13.0938C9.625 13.1797 9.55469 13.25 9.46875 13.25H8.53125C8.44531 13.25 8.375 13.1797 8.375 13.0938V10.125H5.40625C5.32031 10.125 5.25 10.0547 5.25 9.96875V9.03125C5.25 8.94531 5.32031 8.875 5.40625 8.875H8.375V5.90625C8.375 5.82031 8.44531 5.75 8.53125 5.75H9.46875C9.55469 5.75 9.625 5.82031 9.625 5.90625V8.875H12.5938C12.6797 8.875 12.75 8.94531 12.75 9.03125V9.96875Z",
  fill: "currentColor"
});

var SvgPlusCircular = function SvgPlusCircular(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusCircular, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus_circular.60d3c6d5.svg";
export { ForwardRef as ReactComponent };